import * as actionTypes from "../actionTypes.js";

const initialState = {
  companyInfo: null,
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANY_INFO:
      return { ...state, companyInfo: action.payload };

    case actionTypes.LOG_OUT:
      return initialState;
    
    default:
      return state;
  }
};

export default companyReducer;